import { UseFormReturn } from "react-hook-form";
import { PageableResponse } from "../PageableResponse";
import { catchRestError, RestClient } from "../RestClient";

export type B000180FindRequest = Partial<{
  ginkoCdFrom: string;
  ginkoshitenCdFrom: string;
  ginkoCdTo: string;
  ginkoshitenCdTo: string;
  ginkoNm: string;
  shitenNm: string;
  ginkoKana: string;
  shitenKana: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000180FindResponse = {
  ginkoCd: string;
  ginkoshitenCd: string;
  hyojiginkoCd: string;
  ginkoNm: string;
  ginkoKana: string;
  shitenNm: string;
  shitenKana: string;
  hyojiginkoNm: string;
  hyojiginkoKana: string;
  sakujoyoteiKbn: string;
};

export const B000180Find = (props: B000180FindRequest) => {
  return RestClient.get<PageableResponse<B000180FindResponse[]>>(
    "b000180/find",
    { params: props }
  );
};

export type B000180GetRequest = {
  ginkoCd: string;
  ginkoshitenCd: string;
};

export const B000180Get = (props: B000180GetRequest) => {
  return RestClient.get("b000180/get", { params: props });
};

// 銀行名表示
export const B000180GinkoNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.ginkoCd === "" || data.ginkoshitenCd === "") {
    methods.setValue("ginkoNm", "");
    methods.setValue("ginkoshitenNm", "");
    return;
  }
  await B000180Get({ ginkoCd: data.ginkoCd, ginkoshitenCd: data.ginkoshitenCd })
    .then((response) => {
      methods.setValue("ginkoNm", response.data.ginkoNm ?? "");
      methods.setValue("ginkoshitenNm", response.data.shitenNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("ginkoNm", "");
      methods.setValue("ginkoshitenNm", "");
    });
};
